module.exports = __webpack_public_path__ + "static/background-6cd1a7200daac28ced5c6acee79283a3.png";